module.exports = __FOREMAN_VENDOR__NUMBER_HELPERS__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__NUMBER_HELPERS__"
// module id = number_helpers
// module chunks = 32